import React, { useEffect, useRef, useState } from 'react'


import LeftPanel from '../panels/LeftPanel'
import YourQuote from '../cart/YourQuote'

import TShirtPlacement from '../design/TShirtPlacement'
import TShirtPreview from '../preview/TShirtPreview'

import ProductInfoTab from '../preview/ProductInfoTab'

import CustomizerHeader from './CustomizerHeader'

import blackFront from '../../assets/images/black-front.jpg'
import blackBack from '../../assets/images/black-back.jpg'
import blackLeft from '../../assets/images/black-left.png'
import blackRight from '../../assets/images/black-right.png'

import blueFront from '../../assets/images/blue-front.png'
import blueBack from '../../assets/images/blue-back.jpg'
import blueLeft from '../../assets/images/blue-left.png'
import blueRight from '../../assets/images/blue-right.png'

import limeFront from '../../assets/images/lime-front.jpg'
import limeBack from '../../assets/images/lime-back.jpg'
import limeLeft from '../../assets/images/lime-left.png'
import limeRight from '../../assets/images/lime-right.png'

import skyFront from '../../assets/images/sky-front.jpg'
import skyBack from '../../assets/images/sky-back.jpg'
import skyLeft from '../../assets/images/sky-left.png'
import skyRight from '../../assets/images/sky-right.png'

const TShirtCustomizer = () => {
    const customizerRef = useRef(null);
    const colorInputRef = useRef(null);
    const [activeTab, setActiveTab] = useState('product');
    const [placementTexts, setPlacementTexts] = useState({});
    const [placementImages, setPlacementImages] = useState({});
    const [activePlacementKey, setActivePlacementKey] = useState(null);
    const [activeTextId, setActiveTextId] = useState(null);
    const [selectedTextId, setSelectedTextId] = useState(null);
    const [activeImageId, setActiveImageId] = useState(null);
    const [selectedImageId, setSelectedImageId] = useState(null);
    const [placementMethods, setPlacementMethods] = useState({
        front: null,
        back: null,
        left: null,
        right: null,
    });

    const [boxSize, setBoxSize] = useState({width: 0, height: 0});

    const [methodPositions, setMethodPositions] = useState({});

    const [selectedPlacement, setSelectedPlacement] = useState('front');

    // Top header step: 'design' | 'preview' | 'productInfo'
    const [activeStep, setActiveStep] = useState('design');

    const [placementList, setPlacementList] = useState([
        // {
        //   key: 'front-print',
        //   placement: 'front',
        //   method: 'print',
        //   label: formatLabel('front', 'print'),
        // }
    ]);

    const [editingFontSize, setEditingFontSize] = useState(false);
    const [fontSizeInput, setFontSizeInput] = useState('');
    const [editingRoleFontSize, setEditingRoleFontSize] = useState(false);
    const [roleFontSizeInput, setRoleFontSizeInput] = useState('');

    const [selectedColors, setSelectedColors] = useState(['#000000']);
    const [sizes, setSizes] = useState({
        'S': 0,
        'M': 0,
        'L': 0,
        'XL': 0,
        '2XL': 0,
        '3XL': 0,
        '4XL': 0,
        '5XL': 0,
    });

    const [cartOptions, setCartOptions] = useState([]);
    const [referenceImage, setReferenceImage] = useState(null);
    const [orderNote, setOrderNote] = useState('');

    const [cartItems, setCartItems] = useState([]);
    const [addToCartMessage, setAddToCartMessage] = useState('');
    const [showCustomInput, setShowCustomInput] = useState(false);
    const [overlayCenter, setOverlayCenter] = useState({ x: 0, y: 0 });

    const PRICE_PER_UNIT = 90.18;
    const PRINT_TEXT_FEE = 5;
    const EMBROIDERY_FEE = 10;

    const printTextCount = placementList.reduce((count, item) => {
        if (item.method === 'print') {
            return count + (placementTexts[item.key] || []).length;
        }
        return count;
    }, 0);

    // Embroidery: charge +$10 for every element (text + uploaded image)
    // inside every embroidery placement.
    const embroideryElementsCount = placementList.reduce((count, item) => {
        if (item.method !== 'embroidery') return count;

        const textsInPlacement = Array.isArray(placementTexts?.[item.key])
            ? placementTexts[item.key].length
            : 0;
        const imagesInPlacement = Array.isArray(placementImages?.[item.key])
            ? placementImages[item.key].length
            : 0;

        return count + textsInPlacement + imagesInPlacement;
    }, 0);

    const designExtraFeePerUnit =
        printTextCount * PRINT_TEXT_FEE + embroideryElementsCount * EMBROIDERY_FEE;

    const effectivePricePerUnit = PRICE_PER_UNIT + designExtraFeePerUnit;

    const colorOptions = [
        { hex: '#000000', name: 'Black', image: blackFront },
        { hex: '#99DFF9', name: 'Sky', image: skyFront },
        { hex: '#0255A1', name: 'Blue', image: blueFront },
        { hex: '#85CD6A', name: 'Lime', image: limeFront },
    ];

    const totalQtyOfSizes = (sizeMap = {}) =>
        Object.values(sizeMap).reduce((sum, v) => sum + (Number(v) || 0), 0);

    const totalCartQuantity =
        totalQtyOfSizes(sizes) +
        cartOptions.reduce((sum, o) => sum + totalQtyOfSizes(o.sizes), 0);

    const totalCartPrice = totalCartQuantity * effectivePricePerUnit;

    // Itemized breakdown shown in the header's price popover — always
    // derived from the same numbers as totalCartPrice, so they can never
    // drift apart or disagree.
    const priceBreakdown = {
        productQuantity: totalCartQuantity,
        productPrice: PRICE_PER_UNIT * totalCartQuantity,
        customizationCount: printTextCount,
        customizationPrice: printTextCount * PRINT_TEXT_FEE * totalCartQuantity,
        printingMethodCount: embroideryElementsCount,
        printingMethodPrice: embroideryElementsCount * EMBROIDERY_FEE * totalCartQuantity,
        totalPrice: totalCartPrice,
    };

    const handleAddToCart = () => {
        const cartItem = {
            id: `cart-${Date.now()}`,
            productName: 'Custom Product',
            design: {
                placementList,
                placementTexts,
                placementImages,
                methodPositions,
            },
            options: [
                { color: selectedColors[0], sizes },
                ...cartOptions.map((o) => ({ color: o.color, sizes: o.sizes })),
            ],
            referenceImage,
            note: orderNote,
            quantity: totalCartQuantity,
            price: totalCartPrice,
        };

        setCartItems((prev) => [...prev, cartItem]);
        setAddToCartMessage('Added to cart!');
        window.setTimeout(() => setAddToCartMessage(''), 2500);

        // Clear qty after adding to cart (so inputs/table reset).
        setSizes({
            'S': 0,
            'M': 0,
            'L': 0,
            'XL': 0,
            '2XL': 0,
            '3XL': 0,
            '4XL': 0,
            '5XL': 0,
        });
        setCartOptions([]);
    };

    const getMaxFontSize = () => {
        switch (activePlacementKey) {
            case 'front-print':
                return 120;
            case 'front-embroidery':
                return 20;
            case 'back-print':
                return 90;
            case 'back-embroidery':
                return 20;
            default:
                return 20;
        }
    };

    const shirtViewsByColor = {
        '#000000': { front: blackFront, back: blackBack, left: blackLeft, right: blackRight },
        '#99DFF9': { front: skyFront, back: skyBack, left: skyLeft, right: skyRight },
        '#0255A1': { front: blueFront, back: blueBack, left: blueLeft, right: blueRight },
        '#85CD6A': { front: limeFront, back: limeBack, left: limeLeft, right: limeRight },
    };

    const currentViews = (() => {
        const selected = Array.isArray(selectedColors) ? selectedColors[0] : null;
        return shirtViewsByColor[selected] || shirtViewsByColor['#000000'];
    })();

    useEffect(() => {
        if (activeStep !== 'design') return;


        // setSelectedPlacement('front');

        // if (Array.isArray(placementList) && placementList.length > 0) {
        //     // Prefer an existing Front placement so the design tab opens on
        //     // Front with the already selected method preserved.
        //     const frontItem = placementList.find(
        //         (item) => typeof item?.key === 'string' && item.key.startsWith('front-')
        //     );

        //     setActivePlacementKey(frontItem ? frontItem.key : placementList[0].key);
        // } else {
        //     // No placements yet: make sure Front is the active view so the
        //     // preview + method picker open on Front.
        //     setActivePlacementKey(null);
        // }


        if (activeTextId && activePlacementKey) {
            const items = placementTexts?.[activePlacementKey];
            const found = Array.isArray(items) ? items.some((t) => t.id === activeTextId) : false;
            if (!found) setActiveTextId(null);
        }

        if (placementList?.length > 0) {
            const firstKey = placementList[0]?.key;
            if (firstKey) {
                const hasAnyText = Array.isArray(placementTexts?.[firstKey]) && placementTexts[firstKey].length > 0;
                if (!hasAnyText) {
                    setActiveTextId(null);
                    // setActiveTab('text');
                }
            }
        }
    }, [activeStep, activePlacementKey, activeTextId, placementList, placementTexts, setActivePlacementKey, setSelectedPlacement, setActiveTextId, setActiveTab, placementTexts]);


    return (

        <div className='t-shirt-customizer-page'>
            <CustomizerHeader
                activeStep={activeStep}
                setActiveStep={setActiveStep}
                totalPrice={totalCartPrice}
                priceBreakdown={priceBreakdown}
                onAddToCart={handleAddToCart}
            />

            {addToCartMessage && (
                <div
                    className="add-to-cart-toast"
                    style={{
                        position: 'fixed',
                        top: 70,
                        right: 24,
                        background: '#16a34a',
                        color: '#fff',
                        padding: '10px 16px',
                        borderRadius: 8,
                        fontSize: 14,
                        fontWeight: 600,
                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                        zIndex: 1000,
                    }}
                >
                    {addToCartMessage}
                </div>
            )}

            <div ref={customizerRef} className='t-shirt-customizer customizer-body'>
                {activeStep === 'design' && (
                    <>
                        <LeftPanel
                            activeTab={activeTab}
                            setActiveTab={setActiveTab}
                            selectedColors={selectedColors}
                            setSelectedColors={setSelectedColors}
                            sizes={sizes}
                            setSizes={setSizes}
                            placementTexts={placementTexts}
                            setPlacementTexts={setPlacementTexts}
                            placementImages={placementImages}
                            setPlacementImages={setPlacementImages}
                            activePlacementKey={activePlacementKey}
                            placementList={placementList}
                            activeTextId={activeTextId}
                            setActiveTextId={setActiveTextId}
                            editingFontSize={editingFontSize}
                            setEditingFontSize={setEditingFontSize}
                            fontSizeInput={fontSizeInput}
                            setFontSizeInput={setFontSizeInput}
                            getMaxFontSize={getMaxFontSize}
                            editingRoleFontSize={editingRoleFontSize}
                            setEditingRoleFontSize={setEditingRoleFontSize}
                            roleFontSizeInput={roleFontSizeInput}
                            setRoleFontSizeInput={setRoleFontSizeInput}
                            colorInputRef={colorInputRef}
                            setShowCustomInput={setShowCustomInput}
                            showCustomInput={showCustomInput}
                            selectedPlacement={selectedPlacement}
                            overlayCenter={overlayCenter}
                            activeImageId={activeImageId}
                            setActiveImageId={setActiveImageId}
                            setSelectedTextId={setSelectedTextId}
                            setSelectedImageId={setSelectedImageId}
                        />

                        <TShirtPlacement
                            placementTexts={placementTexts}
                            setPlacementTexts={setPlacementTexts}
                            placementImages={placementImages}
                            setPlacementImages={setPlacementImages}
                            activePlacementKey={activePlacementKey}
                            setActivePlacementKey={setActivePlacementKey}
                            placementList={placementList}
                            setPlacementList={setPlacementList}
                            activeTextId={activeTextId}
                            setActiveTextId={setActiveTextId}
                            selectedColors={selectedColors}
                            customizerRef={customizerRef}
                            activeTab={activeTab}
                            setActiveTab={setActiveTab}
                            activeTextId={activeTextId}
                            setActiveTextId={setActiveTextId}
                            selectedTextId={selectedTextId}
                            setSelectedTextId={setSelectedTextId}
                            activeImageId={activeImageId}
                            setActiveImageId={setActiveImageId}
                            selectedImageId={selectedImageId}
                            setSelectedImageId={setSelectedImageId}
                            placementMethods={placementMethods}
                            setPlacementMethods={setPlacementMethods}
                            selectedPlacement={selectedPlacement}
                            setSelectedPlacement={setSelectedPlacement}
                            methodPositions={methodPositions}
                            setMethodPositions={setMethodPositions}
                            overlayCenter={overlayCenter}
                            setOverlayCenter={setOverlayCenter}
                            setBoxSize={setBoxSize}
                        />
                    </>
                )}

                {activeStep === 'preview' && (
                    <TShirtPreview
                        placementList={placementList}
                        placementTexts={placementTexts}
                        placementImages={placementImages}
                        currentViews={currentViews}
                        methodPositions={methodPositions}
                        setActiveStep={setActiveStep}
                        boxSize={boxSize}
                    />
                )}

                {activeStep === 'productInfo' && (
                    <ProductInfoTab
                        currentViews={currentViews}
                        placementList={placementList}
                        placementTexts={placementTexts}
                        placementImages={placementImages}
                        methodPositions={methodPositions}
                        selectedColors={selectedColors}
                        setSelectedColors={setSelectedColors}
                        sizes={sizes}
                        setSizes={setSizes}
                        cartOptions={cartOptions}
                        setCartOptions={setCartOptions}
                        colorOptions={colorOptions}
                        pricePerUnit={effectivePricePerUnit}
                        basePrice={PRICE_PER_UNIT}
                        designExtraFeePerUnit={designExtraFeePerUnit}
                        referenceImage={referenceImage}
                        setReferenceImage={setReferenceImage}
                        note={orderNote}
                        setNote={setOrderNote}
                        onAddToCart={handleAddToCart}
                    />
                )}
            </div>

            {/* <YourQuote /> */}
        </div>
    )
}

export default TShirtCustomizer
